"use strict";
exports.__esModule = true;
exports.layerDefinitionDefault = void 0;
var LayerDefinition_1 = require("../../src/common/interface/LayerDefinition");
var layerDefinitionDefault = [
    {
        level: LayerDefinition_1.ZoomLevel.PROPERTY,
        zoom: 17
    },
    {
        level: LayerDefinition_1.ZoomLevel.BUILDING,
        zoom: 13
    },
    {
        level: LayerDefinition_1.ZoomLevel.DISTRICT,
        zoom: 11
    },
    {
        level: LayerDefinition_1.ZoomLevel.AREA,
        zoom: 0
    },
];
exports.layerDefinitionDefault = layerDefinitionDefault;
